module.exports = __webpack_public_path__ + "static/media/FiraSans-Medium.d7fafde2.ttf";